/* Svensk katalog for locale-superplumma-workspace.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'route.superplumma': 'SuperPlumma',
  'nav.superplumma': 'SuperPlumma',
  'navhelp.superplumma': 'Arbeta tillsammans med SuperPlumma i chatten och se uppgiften i arbetsytan.',
  'spw.eyebrow': 'Din redovisningsassistent',
  'spw.intro': 'Vad ska vi göra i dag? Be mig skapa en faktura eller ladda upp en verifikation. Dokumentet visas här medan vi arbetar med det.',
  'spw.upload': 'Ladda upp verifikation',
  'spw.camera': 'Ta bild',
  'spw.dropHint': 'Du kan också släppa en verifikation här.',
  'spw.drop': 'Släpp verifikationen här',
  'spw.uploading': 'Laddar upp verifikationen …',
  'spw.uploadError': 'Det gick inte att ladda upp verifikationen.',
  'spw.saveDraft': 'Spara utkast',
  'spw.issued': 'Fakturan har skapats.',
  'spw.showProposal': 'Visa förslag',
  'spw.editDetails': 'Ändra detaljer',
  'spw.addReceipt': 'Ladda upp en verifikation i chatten eller ta en bild.',
  'spw.proposal': 'Förslag till bokföring',
  'spw.supplierMissing': 'Ingen leverantör vald',
  'spw.account': 'Konto',
  'spw.vat': 'Moms',
  'spw.notSelected': 'Inte vald',
  'spw.readingHint': 'Förslaget visas när verifikationen har lästs eller detaljerna har fyllts i.',
  'spw.paymentAccount': 'Betalkonto',
  'spw.unpaid': 'Inte betald',
  'spw.approvalHint': 'Be SuperPlumma bokföra när förslaget är klart. Du får kontrollera och godkänna åtgärden.',
  'spw.openTask': 'Öppna uppgiften',
  'spw.chat': 'Chatt',
  'spw.workspace': 'Arbetsyta',
  'spw.shared': 'Samma bokföring. Full överblick.',
  'spw.receipts': 'Verifikationsföring',
  'spw.purchase': 'Köp',
  'spw.sale': 'Försäljning',
  'spw.invoice': 'Fakturautkast',
  'spw.choose': 'Välj uppgift',
  'spw.loading': 'Öppnar arbetsytan …',
  'spw.loadError': 'Arbetsytan kunde inte laddas. Din konversation är sparad.',
  'spw.retry': 'Försök igen',
  'spw.unavailable': 'Öppna SuperPlumma i ett aktivt företag för att börja.',
  'spw.changeTitle': 'Byta uppgift?',
  'spw.changeText': 'Spara eventuella ändringar i formuläret innan du byter uppgift. Ändringar som inte har sparats kan gå förlorade.',
  'spw.changeConfirm': 'Byt uppgift',
});
